import { defineMessages } from './messages';

/**
 * Shared translatable strings used across multiple components.
 * Import these from any component that needs common labels.
 */
export const CommonMessages = defineMessages({
  APP_NAME: {
    id: 'common.app_name',
    text: 'Localingos',
    description: 'Application name used across the UI',
  },
  SIGN_IN: {
    id: 'common.sign_in',
    text: 'Sign in/Sign up',
    description: 'Sign in/up action text',
  },
  SIGN_OUT: {
    id: 'common.sign_out',
    text: 'Sign out',
    description: 'Sign out action text',
  },
  GO_TO_DASHBOARD: {
    id: 'common.go_to_dashboard',
    text: 'Go to Dashboard',
    description: 'CTA button for authenticated users',
  },
  SIGN_UP_CLAIM: {
    id: 'common.sign_up_claim',
    text: 'Sign Up & Claim $10',
    description: 'CTA button for unauthenticated users',
  },
  SIGN_UP_NOW: {
    id: 'common.sign_up_now',
    text: 'Sign Up Now',
    description: 'CTA button for unauthenticated users (short form)',
  },
  SEE_PRICING: {
    id: 'common.see_pricing',
    text: 'See Pricing',
    description: 'Button to navigate to the pricing page',
  },
  ADD_TRANSLATABLES: {
    id: 'common.add_translatables',
    text: 'Add Translatables',
    description: 'Button to navigate to the add translatables page',
  },
  VIEW_TRANSLATIONS: {
    id: 'common.view_translations',
    text: 'View Translations',
    description: 'Button to navigate to the translations page',
  },
  PRIVACY_POLICY: {
    id: 'common.privacy_policy',
    text: 'Privacy Policy',
    description: 'Link text for the privacy policy page',
  },
  NO_LOCALES: {
    id: 'common.no_locales',
    text: 'No locales',
    description: 'Shown when a project has no target locales configured',
  },
  UNNAMED: {
    id: 'common.unnamed',
    text: '(Unnamed)',
    description: 'Fallback label for items without a name',
  },
  DISMISS_BANNER_ARIA: {
    id: 'common.dismiss_banner_aria',
    text: 'Dismiss banner',
    description: 'Aria label for the dismiss button on banners',
  },
  NEXT: {
    id: 'common.next',
    text: 'Next',
    description: 'Generic next button label',
  },
  TARGET_LOCALES_COUNT: {
    id: 'common.target_locales_count',
    text: '{{count}} target locale(s)',
    description: 'Shows the number of target locales for a project. {{count}} is the number',
  },
});